<template>
  <!-- 物联卡列表 -->
  <div class="page">
    <!-- 搜索区域 -->
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="auto" class="from">
        <el-form-item label="车辆编码">
          <el-input
            v-model="searchParams.bikeCode"
            placeholder="请输入车辆编码"
          ></el-input>
        </el-form-item>
        <el-form-item label="ICCID">
          <el-input
            v-model="searchParams.iccid"
            placeholder="请输入ICCID"
          ></el-input>
        </el-form-item>
        <el-form-item label="卡状态">
          <el-select v-model="searchParams.status" placeholder="请选择卡状态">
            <el-option
              v-for="(item, index) in statusList"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!--  <el-form-item label="供应商">
          <el-select v-model="searchParams.supplier" placeholder="请选择供应商">
            <el-option
              v-for="(item, index) in functionList"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运营商">
          <el-select
            v-model="searchParams.functionCode"
            placeholder="请选择运营商"
          >
            <el-option
              v-for="(item, index) in functionList"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="套餐">
          <el-select
            v-model="searchParams.functionCode"
            placeholder="请选择套餐"
          >
            <el-option
              v-for="(item, index) in functionList"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="激活日期">
          <DiluPicker
            :start.sync="searchParams.startActive"
            :stop.sync="searchParams.stopActive"
          />
        </el-form-item>
        <el-form-item label="过期日期">
          <DiluPicker
            :start.sync="searchParams.startExpire"
            :stop.sync="searchParams.stopExpire"
          />
        </el-form-item>
      </el-form>
      <div class="searchSubmit">
        <DiluButton
          type="search"
          @click="search"
        ></DiluButton>
        <DiluButton type="reset" @click="reset"></DiluButton>
      </div>
    </div>
    <!--  <div>
      <el-button @click="search">导出</el-button>
    </div>
    <div class="numberTitle">
      <div>
        <span class="flowTitle">卡总数:</span
        ><span class="flowTitlex">12345</span>
      </div>
      <div>
        <span class="flowTitle">正常:</span
        ><span class="flowTitlex">12345</span>
      </div>
      <div>
        <span class="flowTitle">即将到期:</span
        ><span class="flowTitlex">12345</span>
      </div>
      <div>
        <span class="flowTitle">欠费:</span
        ><span class="flowTitlex">12345</span>
      </div>
    </div> -->
    <!-- 表格 -->
    <DiluTable
      :list="tableData"
      :tableConfig="tableConfig"
      :pageSize="searchParams.pageSize"
      @currentChange="currentChange"
      :total="total"
    >
      <el-table-column prop="date" label="#" width="80" align="center">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="bikeCode" label="车辆编码" align="center">
      </el-table-column>
      <el-table-column prop="iccid" label="ICCID" align="center">
      </el-table-column>
      <el-table-column prop="imsi" label="IMSI" align="center">
      </el-table-column>
      <el-table-column prop="status" label="卡状态" align="center">
        <template slot-scope="scope">
          <div>
            <span v-for="(item, index) in statusList" :key="index">
              {{ item.value == scope.row.status ? item.label : "" }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="usedFlow"
        label="本月使用流量(KB)"
        align="center"
        width="140px"
      >
      </el-table-column>
      <el-table-column
        prop="remainFlow"
        label="本月剩余流量(KB)"
        align="center"
        width="140px"
      >
      </el-table-column>
      <el-table-column
        prop="activeDate"
        label="激活日期"
        width="120px"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.activeDate.slice(0, 10) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="expireDate"
        label="过期日期"
        width="120px"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.expireDate.slice(0, 10) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="updateDate"
        label="数据更新时间"
        width="120px"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.updateDate.slice(0, 10) }}
          </div>
        </template>
      </el-table-column>
    </DiluTable>
  </div>
</template>


<script>
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
import DiluPicker from "../../../components/pubilc/dilu-picker.vue";
export default {
  data() {
    return {
      statusList: [
        {
          label: "正常",
          value: 10,
        },
        {
          label: "即将到期",
          value: 20,
        },
        {
          label: "欠费",
          value: 30,
        },
      ],
      searchParams: {
        bikeCode: "", // 车辆编码
        pageNum: 1, // 页码
        pageSize: 10, // 每页条数
        iccid: "", //iccid
        startActive: "", // 激活开始时间
        stopActive: "", // 激活结束时间
        status: null, // 状态
        startExpire: "", //过期开始时间
        stopExpire: "", //过期结束时间
      },
      tableData: [],
      tableConfig: {
        isTree: false,
        isPage: true,
      },
      total: 0,
    };
  },
  components: {
    DiluButton,
    DiluTable,
    DiluPicker,
  },
  mounted() {
    this.simcardList();
  },
  methods: {
    simcardList() {
      this.request.simcardList(this.searchParams).then((res) => {
        this.tableData = res.data;
        this.total = res.dataMaxCount;
      });
    },
    search() {
      this.searchParams.pageNum = 1;
      this.total = 0;
      this.simcardList();
    },
    reset() {
      this.searchParams = {
        bikeCode: "", // 车辆编码
        pageNum: 1, // 页码
        pageSize: 10, // 每页条数
        iccid: "", //iccid
        startActive: "", // 激活开始时间
        stopActive: "", // 激活结束时间
        status: null, // 状态
        startExpire: "", //过期开始时间
        stopExpire: "", //过期结束时间
      };
      this.total = 0;
      this.simcardList();
    },
    currentChange(e) {
      this.searchParams.pageNum = e;
      this.simcardList();
    },
  },
};
</script>

<style scoped>
.numberTitle {
  display: flex;
  margin: 20px;
}
.flowTitle {
  margin-right: 10px;
}
.flowTitlex {
  margin-right: 20px;
  color: rgb(219, 48, 139);
}
.from {
  float: left;
  display: flex;
}
.searchSubmit {
  float: right;
  display: flex;
}
</style>